import React from 'react';

import { useLanguage } from '@/contexts/LanguageContext';
import { ManifestoText } from '../../molecules';

import styles from './ManifestoSection.module.css';

interface ManifestoSectionProps {
  className?: string;
}

export const ManifestoSection: React.FC<ManifestoSectionProps> = ({
  className,
}) => {
  const titleRef = React.useRef<HTMLHeadingElement>(null);
  const manifestoSectionRef = React.useRef<HTMLElement>(null);
  const { t } = useLanguage();

  return (
    <section
      ref={manifestoSectionRef}
      className={`${styles.manifestoSection} ${className || ''}`}
      aria-label="Manifesto Section"
    >
      <div className={styles.container}>
        <div className={`${styles.manifestoTitle} ${className || ''}`}>
          <h2 ref={titleRef}>{t('home.manifesto.title')}</h2>
        </div>
        <ManifestoText className={styles.text} />
      </div>
    </section>
  );
};
